const formatToPhoneNumber = (value: string | null | undefined): string | null | undefined => {
  if (!value) return value;

  const numbers = value.replace(/\D/g, '');
  const zip = numbers.substring(0, 3);
  const middle = numbers.substring(3, 6);
  const last = numbers.substring(6, 10);

  if (numbers.length > 6) {
    return `(${zip}) ${middle}-${last}`;
  }

  if (numbers.length > 3) {
    return `(${zip}) ${middle}`;
  }

  if (numbers.length > 0) {
    return `(${zip}`;
  }

  return '';
};

export default formatToPhoneNumber;
